/**
 * Central message catalogue. `formatjs extract` scans this file +
 * every `*.tsx` for `defineMessages`/`intl.formatMessage` calls and
 * produces the hash-ID'd JSON in `translations/`.
 *
 * Keep domain-specific messages close to their component; this file
 * only carries app-shell + brand strings that are referenced from
 * multiple places.
 */

import { defineMessages } from 'react-intl';

export const brand = defineMessages({
  productName: {
    id: 'brand.productName',
    defaultMessage: '人材管理',
    description: 'Product name shown in the top bar, document titles, and PDFs.',
  },
  tagline: {
    id: 'brand.tagline',
    defaultMessage: 'HR management for staffing agencies',
    description: 'One-liner for the login page + metadata description.',
  },
});

export const nav = defineMessages({
  home: { id: 'nav.home', defaultMessage: 'Home' },
  dashboard: { id: 'nav.dashboard', defaultMessage: 'Dashboard' },
  workers: { id: 'nav.workers', defaultMessage: 'Workers' },
  candidate: { id: 'nav.candidate', defaultMessage: 'Candidate' },
  candidateRegister: {
    id: 'nav.candidate.register',
    defaultMessage: 'Register Candidate Record',
  },
  candidateList: { id: 'nav.candidate.list', defaultMessage: 'Candidate List' },
  candidateScheduled: {
    id: 'nav.candidate.scheduled',
    defaultMessage: 'Scheduled Interview Candidate List',
  },
  candidateSearch: {
    id: 'nav.candidate.search',
    defaultMessage: 'Candidate Search',
  },
  candidateUnified: {
    id: 'nav.candidate.unified',
    defaultMessage: 'Candidate and Employeed List',
  },
  employees: { id: 'nav.employees', defaultMessage: 'Employees' },
  employeeList: { id: 'nav.employees.list', defaultMessage: 'Employee List' },
  employeeFormer: { id: 'nav.employees.former', defaultMessage: 'Former Employees' },
  employeeSearch: { id: 'nav.employees.search', defaultMessage: 'Employee Search' },
  employeeFormerLeave: {
    id: 'nav.employees.formerLeave',
    defaultMessage: 'Former Vacation Management',
  },
  companies: { id: 'nav.companies', defaultMessage: 'Companies' },
  companyRegister: {
    id: 'nav.companies.register',
    defaultMessage: 'Register Company',
  },
  companyList: { id: 'nav.companies.list', defaultMessage: 'Company List' },
  contracts: { id: 'nav.contracts', defaultMessage: 'Worker Contracts' },
  contractRegister: {
    id: 'nav.contracts.register',
    defaultMessage: 'Register Contract',
  },
  contractList: { id: 'nav.contracts.list', defaultMessage: 'Contract List' },
  contractTemplates: {
    id: 'nav.contracts.templates',
    defaultMessage: 'Contract Templates',
  },
  companyContracts: {
    id: 'nav.companyContracts',
    defaultMessage: 'Company Contracts',
  },
  companyContractRegister: {
    id: 'nav.companyContracts.register',
    defaultMessage: 'Register Company Contract',
  },
  companyContractList: {
    id: 'nav.companyContracts.list',
    defaultMessage: 'Company Contract List',
  },
  companyContractTemplates: {
    id: 'nav.companyContracts.templates',
    defaultMessage: 'Contract Templates',
  },
  vacancies: { id: 'nav.vacancies', defaultMessage: 'Job Opportunities' },
  vacancyRegister: {
    id: 'nav.vacancies.register',
    defaultMessage: 'Register Job Opportunity',
  },
  vacancyList: { id: 'nav.vacancies.list', defaultMessage: 'Job Opportunity List' },
  leave: { id: 'nav.leave', defaultMessage: 'Leave' },
  leaveInbox: { id: 'nav.leave.inbox', defaultMessage: 'Leave inbox' },
  reports: { id: 'nav.reports', defaultMessage: 'Reports' },
  settings: { id: 'nav.settings', defaultMessage: 'Settings' },
  selfProfile: { id: 'nav.selfProfile', defaultMessage: 'My profile' },
});

export const common = defineMessages({
  loading: { id: 'common.loading', defaultMessage: 'Loading…' },
  error: { id: 'common.error', defaultMessage: 'Something went wrong' },
  retry: { id: 'common.retry', defaultMessage: 'Retry' },
  notFound: { id: 'common.notFound', defaultMessage: 'Not found' },
  signOut: { id: 'common.signOut', defaultMessage: 'Sign out' },
  backToList: { id: 'common.backToList', defaultMessage: 'Back to list' },
});
